/*
 * swatch-fallback.js
 * Motion temasındaki renk swatch'larını, Liquid'de rengi bulunamayanlar için
 * tarayıcıda boyar.
 *
 * Sadece renk adına bakar (marka ayrımı yok):
 *   1. window.VARIANT_SWATCHES (varsa, mağazanın kendi listesi)
 *   2. Aşağıdaki hazır renk listesi
 *   3. "Black/ White" gibi çok renkli isimler -> parçalardan çapraz gradient
 *
 * Kurulum: assets/swatch-fallback.js olarak yükle ve layout/theme.liquid içinde
 * </body> öncesine ekle:
 *   <script src="{{ 'swatch-fallback.js' | asset_url }}" defer></script>
 *
 * Marka hex kodları üreticilerin yayınladığı resmi değerler değildir (çoğu marka
 * hex yayınlamaz). Swatch görsellerine göre yaklaşık tonlardır. Yetişkin, genç
 * (youth) ve bebek modelleri aynı renk adlarını kullandığı için tek liste yeterli.
 */
(function () {
  'use strict';

  // Snippet her renk seçeneği için script etiketini tekrar basabilir; tek sefer çalış.
  if (window.__swatchFallbackLoaded) return;
  window.__swatchFallbackLoaded = true;

  var BRANDS = {
    gildan: {
      'Antique Cherry Red': '#971B2F', 'Antique Heliconia': '#AA0061', 'Antique Irish Green': '#00843D',
      'Antique Jade Dome': '#006269', 'Antique Orange': '#B33D26', 'Antique Royal': '#003087',
      'Antique Sapphire': '#006A8E', 'Ash': '#C8C9C7', 'Azalea': '#DD74A1', 'Berry': '#7F2952',
      'Black': '#25282A', 'Blackberry': '#221C35', 'Blue Dusk': '#253746', 'Brown Savana': '#7A6855',
      'Cardinal Red': '#8A1538', 'Carolina Blue': '#7BA4DB', 'Cement': '#AEAEAE', 'Charcoal': '#66676C',
      'Cherry Red': '#AC2B37', 'Cobalt': '#171C8F', 'Coral Silk': '#FB637E', 'Cornsilk': '#F0EC74',
      'Daisy': '#FED101', 'Dark Chocolate': '#382F2D', 'Dark Heather': '#425563', 'Dusty Rose': '#E1BBB4',
      'Electric Green': '#43B02A', 'Forest Green': '#273B33', 'Garnet': '#7D2935', 'Gold': '#EEAD1A',
      'Graphite Heather': '#707372', 'Gravel': '#8A8D8F', 'Heather Cardinal': '#9B2743',
      'Heather Dark Green': '#3C5A47', 'Heather Dark Grey': '#4E4F4A', 'Heather Indigo': '#485A7C', 'Heather Irish Green': '#5CAA7F', 'Heather Galapagos Blue': '#2E6F8E', 'Heather Berry': '#9B4A6E',
      'Heather Military Green': '#7E7F74', 'Heather Navy': '#333F48', 'Heather Orange': '#E87A4F',
      'Heather Purple': '#614B79', 'Heather Radiant Orchid': '#A15A95', 'Heather Red': '#BF0D3E',
      'Heather Royal': '#307FE2', 'Heather Sapphire': '#0076A8', 'Heather Sport Dark Green': '#2C4A3A',
      'Heather Sport Dark Maroon': '#5C2733', 'Heather Sport Dark Navy': '#2A3242',
      'Heather Sport Royal': '#335D9F', 'Heather Sport Scarlet Red': '#B53A3E', 'Heliconia': '#DB3E79',
      'Ice Grey': '#D7D2CB', 'Indigo Blue': '#486D87', 'Irish Green': '#00A74A', 'Island Reef': '#8FD6BD',
      'Jade Dome': '#008E85', 'Kelly Green': '#00805F', 'Kiwi': '#89A84F', 'Light Blue': '#A4C8E1',
      'Light Pink': '#E4C6D4', 'Lilac': '#7A5C99', 'Lime': '#92D050', 'Maroon': '#5B2B42',
      'Metro Blue': '#464E7E', 'Midnight': '#004650', 'Military Green': '#5E7461', 'Mint Green': '#A0CFA8',
      'Natural': '#E7DBC0', 'Navy': '#263147', 'Neon Green': '#6ECB4A', 'Old Gold': '#C59D5F',
      'Olive': '#5E5B3E', 'Orange': '#F4633A', 'Orchid': '#D4A2CE', 'Paprika': '#A13C2A',
      'Pistachio': '#A9C47F', 'Pitch Black': '#101820', 'Prairie Dust': '#7A7256', 'Purple': '#4F2D7F',
      'Red': '#D50032', 'Royal': '#224D8F', 'Russet': '#512F2E', 'Safety Green': '#C6D219',
      'Safety Orange': '#E5801C', 'Safety Pink': '#E16F8F', 'Sage': '#819E87', 'Sand': '#CABFAD',
      'Sapphire': '#0077B5', 'Sky': '#71C5E8', 'Smoke': '#3D3935', 'Sport Grey': '#97999B',
      'Stone Blue': '#7E93A7', 'Sunset': '#DC6B2F', 'Tan': '#BD9A7A', 'Tangerine': '#FF8A3D',
      'Tennessee Orange': '#F78D2D', 'Texas Orange': '#B65A30', 'Tropical Blue': '#00859B',
      'Turf Green': '#279142', 'Tweed': '#4F5051', 'Vegas Gold': '#C6B784', 'Violet': '#8094DD',
      'White': '#FFFFFF', 'Yellow Haze': '#F0E87B'
    },

    'bella-canvas': {
      'Aqua': '#00A6B2', 'Army': '#5D5847', 'Ash': '#E7E7E3', 'Asphalt': '#50514F',
      'Athletic Heather': '#B2B4B3', 'Autumn': '#B66A3B', 'Berry': '#AE2573', 'Black': '#0C0C0C',
      'Black Heather': '#3B3B3B', 'Brown': '#4E3629', 'Burnt Orange': '#CC5500', 'Canvas Red': '#C8102E',
      'Cardinal': '#862633', 'Charity Pink': '#F3A0BC', 'Coral': '#F67B74', 'Dark Grey': '#3E3F41',
      'Dark Grey Heather': '#4B4D4C', 'Deep Heather': '#8E8F8D', 'Deep Teal': '#004F59', 'Dust': '#C9B9A7',
      'Dusty Blue': '#8FA9C2', 'Evergreen': '#2D4636', 'Forest': '#253C31', 'Gold': '#F1B434',
      'Heather Blue Lagoon': '#5DA3B7', 'Heather Brown': '#7B6553', 'Heather Cardinal': '#A0384B',
      'Heather Clay': '#B87B66', 'Heather Columbia Blue': '#9AC1DE', 'Heather Deep Teal': '#2F6B73',
      'Heather Dust': '#DCCFC0', 'Heather Forest': '#506757', 'Heather Grass Green': '#6EA36B',
      'Heather Ice Blue': '#B8D3E2', 'Heather Kelly': '#3D9A6E', 'Heather Mauve': '#C5A3A1',
      'Heather Military Green': '#7C7E66', 'Heather Mint': '#A6D9C6', 'Heather Mustard': '#E3BA59',
      'Heather Natural': '#E6DDC9', 'Heather Navy': '#363F52', 'Heather Olive': '#878662',
      'Heather Orange': '#EE7C4A', 'Heather Orchid': '#C9A3C7', 'Heather Peach': '#F3C3AD',
      'Heather Prism Blue': '#A9C9E1', 'Heather Prism Dusty Blue': '#A3B8CB',
      'Heather Prism Ice Blue': '#C6DDE6', 'Heather Prism Lilac': '#CDB6D4', 'Heather Prism Mint': '#BFE1D1',
      'Heather Prism Natural': '#EDE3D1', 'Heather Prism Peach': '#F6CBB7', 'Heather Prism Sunset': '#F5B7A3',
      'Heather Purple': '#6D5A8C', 'Heather Raspberry': '#C04B71', 'Heather Red': '#C8414D',
      'Heather Royal': '#3F6AB3', 'Heather Sea Green': '#6EB3A2', 'Heather Slate': '#6A7884',
      'Heather Stone': '#CBC1B2', 'Heather Storm': '#8B8E91', 'Heather Sunset': '#F29E7F',
      'Heather Teal': '#3B8389', 'Heather True Royal': '#3C62AE', 'Heather Yellow Gold': '#E9B949',
      'Kelly': '#00855F', 'Leaf': '#5E8E4B', 'Light Blue': '#A9C6E8', 'Maroon': '#5F2A35',
      'Mauve': '#C4958F', 'Military Green': '#5C5E46', 'Mint': '#A8DDC4', 'Mustard': '#E0A53B',
      'Natural': '#EFE7D6', 'Navy': '#212842', 'Ocean Blue': '#2F8DC4', 'Olive': '#6A6743',
      'Orange': '#F26B21', 'Orchid': '#D49CC9', 'Oxblood Black': '#3E1D23', 'Pebble Brown': '#A49382',
      'Pink': '#F7C5D1', 'Poppy': '#EA4F52', 'Red': '#C8102E', 'Rust': '#A4493D', 'Sage': '#9AAA8F',
      'Sand Dune': '#D5C3A8', 'Silver': '#C6C7C8', 'Soft Cream': '#F2E7D2', 'Soft Pink': '#F6D1D1',
      'Solid Black Blend': '#2B2B2B', 'Solid White Blend': '#F0F0F0', 'Steel Blue': '#4A6E8A',
      'Sunset': '#F69A6F', 'Tan': '#C9A27E', 'Teal': '#008B8B', 'Team Purple': '#4F2D7F',
      'Toast': '#C88C5A', 'True Royal': '#2B53A4', 'Turquoise': '#2AB0C4', 'Vintage Black': '#2A2A2A',
      'Vintage White': '#F6F3EA', 'White': '#FFFFFF', 'Yellow': '#FAD94B'
    },

    'comfort-colors': {
      'Banana': '#F4E2A3', 'Bay': '#B9C3A7', 'Berry': '#9C3D5E', 'Black': '#2A2A2A', 'Blossom': '#F2C2C7',
      'Blue Jean': '#6D87A2', 'Blue Spruce': '#536964', 'Boysenberry': '#6B2D4D', 'Brick': '#8A4B42',
      'Burgundy': '#6D2B3A', 'Burnt Orange': '#C46B3E', 'Butter': '#F6E2A2', 'Chalky Mint': '#A9D6C3',
      'Chambray': '#A9BCCB', 'Crimson': '#9B3A3F', 'Crunchberry': '#DD6E8D', 'Denim': '#5D6C84',
      'Espresso': '#5B4A3E', 'Flo Blue': '#6B8BC5', 'Granite': '#636363', 'Graphite': '#4E4E4E',
      'Grape': '#6C4B73', 'Grey': '#8F8F8F', 'Hemp': '#6C6E4B', 'Hydrangea': '#A8BDDC',
      'Ice Blue': '#8FA5B1', 'Island Green': '#4C9D89', 'Island Reef': '#90D3BF', 'Ivory': '#F2E9D4',
      'Khaki': '#BAA880', 'Lagoon Blue': '#70B9CA', 'Light Blue': '#AFC7DA', 'Light Green': '#8EAB8B',
      'Midnight': '#384659', 'Moss': '#6F704D', 'Mustard': '#DAA542', 'Navy': '#2F3A53',
      'Neon Blue': '#3D8BE0', 'Neon Cantaloupe': '#FF9E6B', 'Neon Green': '#7BE05A', 'Neon Lemon': '#ECF253',
      'Neon Pink': '#FF6FB0', 'Neon Red Orange': '#FF5A3C', 'Neon Violet': '#A36BE0', 'Orchid': '#B696B9',
      'Paprika': '#B54A36', 'Peachy': '#F8C9A9', 'Pepper': '#4F4E4A', 'Red': '#B33B3B',
      'Royal Caribe': '#3080B5', 'Sage': '#909F86', 'Sandstone': '#C3AA88', 'Seafoam': '#6EA99D',
      'Terracotta': '#C97761', 'True Navy': '#2D3651', 'Violet': '#8B85B6', 'Washed Denim': '#7F98B5',
      'Watermelon': '#DA5760', 'White': '#F8F8F3', 'Yam': '#CC6B3D'
    }
  };

  // ---------- isim normalizasyonu ----------
  // "White/ Denim", "White/Denim", "white-denim", "White / Denim - 12" hepsi aynı anahtara düşer
  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\s*-\s*\d+$/, '')
      .replace(/\(disc\)/g, '')
      .replace(/[-_]+/g, ' ')
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // ---------- tek isim listesi: renk adı -> renk ----------
  // Öncelik: window.VARIANT_SWATCHES (mağazanın kendi listesi) > yukarıdaki hazır liste.
  // Aynı isim birden fazla grupta varsa ilk bulunan kullanılır.
  var builtIn = null, storeIdx = {}, storeSrc;

  function getBuiltIn() {
    if (builtIn) return builtIn;
    builtIn = {};
    Object.keys(BRANDS).forEach(function (b) {
      Object.keys(BRANDS[b]).forEach(function (name) {
        var k = norm(name);
        if (!builtIn[k]) builtIn[k] = { hex: BRANDS[b][name] };
      });
    });
    return builtIn;
  }

  function getStoreIdx() {
    var src = window.VARIANT_SWATCHES || null;
    if (src !== storeSrc || !storeIdx) {
      storeSrc = src;
      storeIdx = {};
      if (src) {
        Object.keys(src).forEach(function (name) {
          var d = src[name] || {};
          if (d.img || d.hex) storeIdx[norm(name)] = { hex: d.hex, img: d.img };
        });
      }
    }
    return storeIdx;
  }

  function lookupSingle(name) {
    var k = norm(name);
    return getStoreIdx()[k] || getBuiltIn()[k] || null;
  }

  // Renk adına göre arama: { img } | { hex } | { gradient } | null
  function swatchLookup(name) {
    var direct = lookupSingle(name);
    if (direct) return direct;

    // Çok renkli isimler: "Black/ White", "Navy/ White/ Red"
    var parts = norm(name).split('/').filter(Boolean);
    if (parts.length > 1) {
      var hexes = [];
      for (var i = 0; i < parts.length; i++) {
        var p = lookupSingle(parts[i]);
        if (!p || !p.hex) return null;
        hexes.push(p.hex);
      }
      var step = 100 / hexes.length, stops = [];
      hexes.forEach(function (h, idx) {
        stops.push(h + ' ' + (idx * step) + '%', h + ' ' + ((idx + 1) * step) + '%');
      });
      return { gradient: 'linear-gradient(135deg, ' + stops.join(', ') + ')' };
    }
    return null;
  }

  window.swatchLookup = swatchLookup;

  // ---------- Motion swatch'larını boya ----------
  // !important ile yazıyoruz ki tema CSS'i veya inline stil ezmesin.
  function paint(el, data) {
    var st = el.style;
    if (data.img) {
      st.setProperty('background-image', 'url("' + data.img + '")', 'important');
      st.setProperty('background-size', 'cover', 'important');
      st.setProperty('background-position', 'center', 'important');
    } else if (data.gradient) {
      st.setProperty('background-image', data.gradient, 'important');
    } else if (data.hex) {
      st.setProperty('background-image', 'none', 'important');
      st.setProperty('background-color', data.hex, 'important');
    }
    el.setAttribute('data-swatch-painted', '1');
  }

  // Shopify'ın kendi swatch'ı (native) ve Files'taki PNG'ler (file) hariç
  // tüm renk swatch'larını renk adına göre boyar.
  function run() {
    var sel = 'label.color-swatch:not([data-swatch-source="native"]):not([data-swatch-source="file"])';
    var found = 0, painted = 0, missing = [];
    document.querySelectorAll(sel).forEach(function (el) {
      found++;
      var input = el.previousElementSibling;
      var name = el.getAttribute('data-swatch-name') ||
        (input && input.value) ||
        el.textContent;
      var data = swatchLookup(name);
      if (data) { paint(el, data); painted++; }
      else missing.push(String(name).trim());
    });
    return { found: found, painted: painted, missing: missing };
  }

  // Konsoldan elle test: swatchFallbackRun()
  window.swatchFallbackRun = run;

  function start() {
    run();
    // Tema swatch'ları sonradan yeniden çizebilir; birkaç kez daha dene
    window.addEventListener('load', run);
    setTimeout(run, 1000);
    setTimeout(run, 3000);
    // Quick view / variant değişimi ile gelen yeni swatch'lar
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();